import React from "react";
import {inject, observer } from 'mobx-react';
import {Link, withRouter} from 'react-router-dom';
import HttpClient from "services/HttpClient";
import classNames from 'classnames';
import {IACP_LOGO} from 'constants/sponsor_logos';
import {Logo} from 'components/svgs/NonLoggedUserLogo';
import CarouselWrapper from "components/new_user/CarouselWrapper";


const GET_IACP_USER = "/api/v1/users/iacp_login";
const POST_IACP_AGREE = "/api/v1/users/aggre_terms";

@inject('SponsorStore', "alert", 'user')
@observer
@withRouter
class IacpUser extends React.Component {
  state = {
    user: null,
    token: null,
    tsAgree: false
  };

  componentWillMount = () => {
    this.logoutAndProceed();
  }

  logoutAndProceed = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("purchaseMessageSeen");
    this.props.user.setUser(null);
    const token = this.props.location.search.slice(7);
    this.getIACPUser(token);
  }


  getIACPUser = token => {
    const tokenSaved = localStorage.getItem('token');
    const taAgreement = localStorage.getItem('taAgreement');

    if (tokenSaved && !taAgreement) {
      this.props.history.push('/iacp');
    } else {
      new HttpClient().post(GET_IACP_USER, {token: token}).then(response => {
        if (response.status === 200) {
          if (response.body.data.user.terms_agreed) {
            this.loginAndRedirect(response.body.data);
          } else {
            this.handleSuccess(response.body.data);
          }
        }
      });
    }
  }

  loginAndRedirect = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user) );
    this.props.user.loginUser(data.user);
    this.props.history.push('/iacp')
  }

  handleSuccess = data => {
    this.setState({
      user: data.user,
      token: data.token
    });
    localStorage.setItem('token', data.token);
  };

  handleChangeAgree = () => {
    this.setState({
      tsAgree: !this.state.tsAgree
    })
  }

  sendAgree = () => {
    new HttpClient().post(POST_IACP_AGREE).then(response => {
      if (response.status === 200) {
        localStorage.setItem('user', JSON.stringify(response.body.data.user) );
        this.props.user.loginUser(response.body.data.user);
        this.props.history.push('/iacp')
      }
    });
  }

  authUser = () => {
    const sponsorLogo = (
      // for future logic with diff sponsorId's
        <div className='row'>
          <div className="col">
            <div className='spons-logo-newuser'>
              <img src={IACP_LOGO} alt="spons"/>
            </div>
          </div>
        </div>
      )

    return (
      <main className="main-content iacp-user">
        <div className="container-fluid">
          <div className="sign-up row">
          <div className="col-4 hide-xs hide-s">
            <CarouselWrapper/>
          </div>
          <div className="col-12 col-md-5">
            <div className="row  align-items-center sign-up-form-holder">
              <div className="col-12 col-md-11">
                {sponsorLogo}
                <div className="row">
                  <div className="col">
                    <h1 className="sign-up-title">Accessing  IACP's modules on Therapy Academy</h1>
                    <p className="sign-up-greeting">We're now creating your account on Therapy Academy to enable you to access the IACP's online modules on Therapy Academy</p>

                    <p className="sign-up-please">Please accept the Terms of Service to continue</p>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col">
                    <div className="checkbox">
                      <input type="checkbox" id='tsagree' name='tsagree' checked={this.state.tsAgree} onChange={this.handleChangeAgree}/>
                      <label htmlFor="tsagree" />
                      <Link to='/termsofconditions'>I agree to the Terms of Service</Link>
                    </div>
                  </div>
                </div>
                <div className="btn-agree-con">
                  <button
                    className={classNames("btn empty bordered", {blue: this.state.tsAgree, disabled: !this.state.tsAgree})}
                    disabled={!this.state.tsAgree}
                    onClick={this.sendAgree}
                  >continue</button>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </main>
    )
  }

  render() {
    return (
      <div>
        <header className="main-header sign-up-header" id="newUser">
          <div className="container-fluid">
            <div className="row justify-content-between">
              <div className="col-6 col-md-2">
                <Link to="/" className="logo">
                  {Logo}
                </Link>
              </div>
            </div>
          </div>
        </header>
        {this.authUser()}
      </div>
    )
  }
}

export default IacpUser;


// WEBPACK FOOTER //
// ./src/components/iacp_user/IacpUser.jsx